import { Component, Input, OnInit } from '@angular/core';
import { transitionNewLiInOut } from 'animations-lib';
import { IEntityProfile } from 'interfaces-lib';
import { runtimeEnvironment } from '../../environments/environment';
import { ServiceProviderService } from '../services/service.provider.service';
import { IEntityProfileService } from './ientityprofileservice';

@Component({
    selector: 'app-entity-preview',
    templateUrl: './entity-preview.component.html',
    styleUrls: ['./entity-preview.component.scss'],
    animations: [transitionNewLiInOut],
    standalone: false
})
export class EntityPreviewComponent implements OnInit {
  @Input()
  namespace = '';

  renderMode = runtimeEnvironment.renderMode;
  profile: IEntityProfile;
  noProfilePic = true;

  entityProfileService: IEntityProfileService;

  constructor(private serviceProviderService: ServiceProviderService) {
    this.entityProfileService = serviceProviderService.getEntityProfileService(runtimeEnvironment.origin.namespace);
    this.entityProfileService.entityProfileSelected$.subscribe((profile) => {
      this.profile = profile;
    });
  }

  ngOnInit(): void {}

  imageLoaded(): void {
    this.noProfilePic = false;
  }
}
